(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-popups"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const popups = document.querySelectorAll('.custom-popups .popup');
  const enableBlur = document.querySelector('.custom-popups')?.dataset.blur === 'true';
  const currentPath = window.location.pathname;

  popups.forEach(popup => {
    const id = popup.id;
    const delay = parseInt(popup.dataset.delay || 0);
    const reappearDays = parseInt(popup.dataset.reappear || 7);
    const animation = popup.dataset.animation;
    const displayOn = popup.dataset.display;
    const customUrls = (popup.dataset.customUrls || '').split(',').map(u => u.trim());
    const lastShown = localStorage.getItem(id);

    // Skip if already shown recently
    if (lastShown && (Date.now() - parseInt(lastShown)) < reappearDays * 86400000) return;

    // Page visibility check
    const showOnThisPage =
      displayOn === 'all' ||
      (displayOn === 'home' && currentPath === '/') ||
      (displayOn === 'product' && currentPath.includes('/products/')) ||
      (displayOn === 'collection' && currentPath.includes('/collections/')) ||
      (displayOn === 'cart' && currentPath.includes('/cart')) ||
      (displayOn === 'custom' && customUrls.includes(currentPath));

    if (!showOnThisPage) return;

    // Show popup after delay
    setTimeout(() => {
      popup.classList.add('active', animation);
      document.body.classList.add('popup-open'); // 👈 Prevent background scroll

      if (enableBlur) {
        document.querySelector('main, header, footer')?.classList.add('blurred-bg');
      }
    }, delay * 1000);

    const closeHandler = () => {
      popup.classList.remove('active', animation);
      document.body.classList.remove('popup-open'); // 👈 Re-enable scroll

      if (enableBlur) {
        document.querySelector('main, header, footer')?.classList.remove('blurred-bg');
      }

      localStorage.setItem(id, Date.now());
    };

    popup.querySelector('.popup-close')?.addEventListener('click', closeHandler);
    popup.querySelector('.popup-overlay')?.addEventListener('click', closeHandler);
  });
});

  } catch(e) { console.error(e); }
})();
})();
